import { MobileLayout } from 'components/mobile/MobileLayout/MobileLayout';
import styles from '../styles/pages/SportsBetting.module.css';
import { SportList } from 'components/SportList/SportList';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { Layout } from 'components/Layout/Layout';
import { ResultsBetting } from 'components/ResultsBetting/ResultsBetting';
import { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { getSports } from 'services/api/sportBetsService';
import { Loader } from 'components/Loader/Loader';

export const Results = () => {
  const { isMobile } = useBreakpoint();
  const [allSports, setAllSports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useAsyncEffect(async () => {
    try {
      const gamesResponse = await getSports(undefined, { results: true });
      setIsLoading(false);
      setAllSports(gamesResponse ?? []);
    } catch {
      setIsLoading(false);
    }
  }, []);

  return (
    <>
      {isMobile ? (
        <MobileLayout>
          <div className={styles.wrapper}>
            {isLoading ? (
              <Loader />
            ) : (
              <SportList sports={allSports} resultsMode />
            )}
          </div>
        </MobileLayout>
      ) : (
        <Layout whiteBg>
          <ResultsBetting />
        </Layout>
      )}
    </>
  );
};
